import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "reactstrap";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import ProtectedImage from "../common/ProtectedImage";
import { RootStoreContext } from "../../app/stores/rootStore";
import { toast } from "react-toastify";

interface IParams {
  selectedIndex: number;
  onThumbnailClick: (index: number) => void;
  toggle: () => void;
  thumbnails: {
    original: string;
    thumbnail: string;
    totalNumber: number;
    index: number;
  }[];
}

const ThumbnailGridScreen: React.FC<IParams> = ({
  thumbnails,
  selectedIndex,
  onThumbnailClick,
  toggle,
}) => {
  const imgRef = useRef<null | HTMLDivElement>(null);
  const rootStore = useContext(RootStoreContext);
  const { isMobileMediaQuery } = rootStore.responsiveStore
  const { broadcastLauncherTypes, subscribers, publisher, broadcastUser,isBroadcastControllerOpen } = rootStore.broadcastStore;
  const { attendingMeeting } = rootStore.playerStore;
  const [disableMarginleft, setDisableMarginleft]= useState<boolean>(false);
 useEffect(() => {
    const currentUrl = window.location.href;
    if (currentUrl.includes("podium")|| currentUrl.includes("guest")) {
      //  console.log("L'URL contiene 'podium':", currentUrl);
      // console.log("L'URL contiene 'podium':", currentPodium);
      // eventuale logica aggiuntiva
      setDisableMarginleft(true);
    }
  

    const scrollableElement = document.querySelector(".thumb-grid-open");
    if (scrollableElement) disableBodyScroll(scrollableElement);
    if (imgRef.current)
      imgRef.current?.scrollIntoView({
        behavior: "auto",
        block: "nearest",
        inline: "nearest",
      });

    return () => {
      const scrollableElement = document.querySelector(".thumb-grid-open");
      if (scrollableElement) enableBodyScroll(scrollableElement);
    };
  }, []);

  return (
    // <div className="thumb-grid-open" onClick={toggle} style={{marginLeft:"15px"}}>
    // <div className="thumb-grid-open" onClick={toggle} style={{marginLeft:(attendingMeeting && broadcastLauncherTypes && broadcastLauncherTypes !== "undefined") ?"15px":"0px"}}></div>
  //  <div className="thumb-grid-open" onClick={toggle} style={{marginLeft:(attendingMeeting || broadcastLauncherTypes || broadcastLauncherTypes !== "undefined") ?"15px":"0px"}}>
  <div className="thumb-grid-open" onClick={toggle} style={{marginLeft:( !disableMarginleft && (attendingMeeting || broadcastLauncherTypes || broadcastLauncherTypes !== "undefined")) ?"15px":"0px"}}>
      <Row>
        {thumbnails.map((t) => (
          <>
            <Col
              xs={6}
              sm={4}
              md={3}
              lg={2}
              key={t.index}
              className="mb-4 text-center"
            >
              <div
                ref={selectedIndex === t.index - 1 ? imgRef : undefined}
                onClick={() => onThumbnailClick(t.index)}
                className={classNames(
                  "d-inline-block px-2",
                  selectedIndex === t.index - 1
                    ? "image-gallery-selected-thumbnail"
                    : ""
                )}
              >
                <ProtectedImage url={t.thumbnail} className="image-gallery-image image-gallery-div" />
                <div className="image-gallery-text-container-grid">
                  <h6 className="customh6">
                    {t.index}/{t.totalNumber}
                  </h6>
                </div>
              </div>
            </Col>
          </>
        ))}
      </Row>
    </div>
  );
};

export default observer(ThumbnailGridScreen);
